export const defaultDxfFileName = "demo图纸.dxf";
// The neutral extension keeps servers from transparently decoding the gzip payload.
const defaultDxfUrl = "/货架.dxf.bin";

export async function loadDefaultDxfFile() {
  const response = await fetch(defaultDxfUrl);
  if (!response.ok) {
    throw new Error(`无法读取${defaultDxfFileName}：${response.status}`);
  }
  if (!response.body) {
    throw new Error(`无法解压${defaultDxfFileName}`);
  }

  const stream = response.body.pipeThrough(new DecompressionStream("gzip"));
  const blob = await new Response(stream).blob();
  return new File([blob], defaultDxfFileName, { type: "application/dxf" });
}

export async function downloadDefaultDxfFile() {
  const file = await loadDefaultDxfFile();
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.download = file.name;
  link.href = url;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
